export enum MarginHousingType {
    Apt = 1,
    Hotel = 2,
    FacilityProvided = 3
}
